import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/import-status.css';
import { ReactComponent as TickMark } from 'assets/images/tick-mark.svg';
import { ReactComponent as Error } from 'assets/images/warning.svg';

export const Importing = () => {
  return (
    <div className="importing">
      <div className="status">Importing files...</div>
    </div>
  );
};

export const SuccessFullyImported = () => {
  return (
    <div className="import-successful">
      <div>
        <TickMark/>
      </div>
      <div className="status">Your file import succesfully completed</div>
    </div>
  );
};

export const ImportUnsuccessful = ({ error, handleInputButtonClick }) => {
  return (
    <div className="import-unsuccessful">
      <div className="import-unsuccessful-content">
        <div>
          <Error/>
        </div>
        <div className="status">{error ? error : 'File import unsuccessful'}</div>
      </div>
      <div className="try-again" onClick={handleInputButtonClick}>
        Try again
      </div>
    </div>
  );
};

ImportUnsuccessful.propTypes = {
  error: PropTypes.string,
  handleInputButtonClick: PropTypes.func
};
